var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 38,
    height: 40.0007,
    rx: 6,
    fill: "#FFF4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.99951C17.4477 7.99951 17 8.44723 17 8.99951C17 9.5518 17.4477 9.99951 18 9.99951H20C20.5523 9.99951 21 9.5518 21 8.99951C21 8.44723 20.5523 7.99951 20 7.99951H18ZM19 30.5002C14.1675 30.5002 10.25 26.5827 10.25 21.7502C10.25 16.9178 14.1675 13.0002 19 13.0002C19.29 13.0002 19.5765 13.0143 19.8589 13.0418L20.0042 11.5489C19.6736 11.5167 19.3386 11.5002 19 11.5002C13.3391 11.5002 8.75 16.0893 8.75 21.7502C8.75 27.4112 13.3391 32.0002 19 32.0002C24.6609 32.0002 29.25 27.4112 29.25 21.7502C29.25 21.4116 29.2336 21.0767 29.2014 20.7461L27.7084 20.8914C27.7359 21.1737 27.75 21.4602 27.75 21.7502C27.75 26.5827 23.8325 30.5002 19 30.5002ZM28.0411 16.9171C28.3555 17.5041 28.6145 18.1255 28.8111 18.7741L27.3755 19.2091C27.208 18.6561 26.9871 18.1262 26.7188 17.6253L28.0411 16.9171ZM25.503 13.8269C26.0215 14.2529 26.4974 14.7288 26.9234 15.2473L25.7644 16.1995C25.4004 15.7565 24.9937 15.3498 24.5507 14.9859L25.503 13.8269ZM21.9761 11.9392C22.6248 12.1357 23.2461 12.3947 23.8332 12.7092L23.1249 14.0314C22.624 13.7631 22.0941 13.5423 21.5412 13.3748L21.9761 11.9392ZM25.4672 20.0715C25.8189 20.9207 26 21.831 26 22.7502H19V15.7502C19.9193 15.7502 20.8295 15.9313 21.6788 16.2831C22.5281 16.6349 23.2997 17.1505 23.9497 17.8005C24.5998 18.4505 25.1154 19.2222 25.4672 20.0715Z",
    fill: "#D11B07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTimer);
export default __webpack_public_path__ + "static/media/red_timer.bed03b93eb5338f27a8070b1b2b60264.svg";
export { ForwardRef as ReactComponent };